$initialHourClockRotation: 125deg;


.time-settings-button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding:0;

    & button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        gap: 0.25rem;
        height: 2.25rem;
        width:  3.375rem;

        border: none;

        font-family: var(--font-stack);
        font-size: 0.8rem;
        white-space: nowrap;
        background: var(--color-bg-primary);
        color: var(--color-text-primary);

        user-select: none;
        cursor: pointer;

        &:hover {
            background: var(--color-bg-primary-hover);
            transition: all 0.3s ease-in-out;

            & .time-settings-clock-icon svg:last-child {
                animation: singleRotation 0.5s linear forwards;
            }
        }

        & .time-settings-clock-icon {
            position: relative;
            width: 22px;
            height: 22px;
            font-size: 1.375rem;
            animation: none;

            svg {
                width: 22px;
                height: 22px;
                position: absolute;
                top: 0;
                left: 0;
                fill: var(--color-icon-primary);
            }

            svg:last-child {
                transform: rotateZ($initialHourClockRotation);
            }

            @keyframes singleRotation {
                to {
                    transform: rotateZ($initialHourClockRotation + 360deg);
                }
            }
        }

        & .time-settings-icon {
            font-size: 1.375rem;
            fill: var(--color-icon-primary);

            &--calendar {
                font-size: 1.125rem;
            }

            &--live {
                font-size: 1.125rem;

                animation: slow-rotation 5s ease-in-out;
                animation-iteration-count: infinite;
            }
        }
    }
    svg path {
        fill: var(--color-icon-primary) !important;
    }

    & .btn-left {
        border: 1px solid var(--color-bg-subtle);
        border-radius: 50vh 0 0 50vh;
        padding-left: 0.5rem;
        color: var(--color-icon-primary);
    }

    & .btn-center {
        border-top: 1px solid var(--color-bg-subtle);
        border-bottom: 1px solid var(--color-bg-subtle);
        width: 12.5rem;
    }

    & .btn-right {
        border: 1px solid var(--color-bg-subtle);
        border-radius: 0 50vh 50vh 0;
        padding-right: 0.5rem;
    }
}

.rounded-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;

    font-family: var(--font-stack);
    font-size: 0.75rem;
    white-space: nowrap;

    border: 1px solid var(--color-bg-subtle);
    background-color: #ffffff;
    border-radius: 50vh;
    color: var(--color-text-primary);;

    user-select: none;
    cursor: pointer;


    &:active {
      border: 1px solid #86908d;
    }

    cursor: pointer;

    &button:hover {
      background-color: var(--mm-gray-2);
      transition: all 0.3s ease-in-out
    }
}

@keyframes slow-rotation {
    0% {
        transform: rotateZ(0deg);
    }

    50% {
        transform: rotateZ(180deg);
    }

    100% {
        transform: rotateZ(360deg);
    }
}
